import { useBlockProps, RichText } from "@wordpress/block-editor";
import { __ } from "@wordpress/i18n";

export default function Edit({ attributes, setAttributes }) {
  const { label } = attributes;
  // Block-support props go on the button surface (the __link element), matching
  // core/button and the frontend render.
  const blockProps = useBlockProps({
    className: "wp-block-button__link wp-element-button",
  });

  return (
    <div className="wp-block-button">
      <RichText
        tagName="span"
        {...blockProps}
        value={label}
        onChange={(value) => setAttributes({ label: value })}
        placeholder={__("View category", "brandy-blocks")}
        allowedFormats={[]}
        withoutInteractiveFormatting
      />
    </div>
  );
}
